var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "counter" }, [
    _c(
      "div",
      {
        staticClass: "counter__button counter__button_left",
        on: { click: _vm.decrement },
      },
      [_c("span", { staticClass: "lnr lnr-chevron-left" })]
    ),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.num,
          expression: "num",
        },
      ],
      attrs: { type: "text", disabled: "" },
      domProps: { value: _vm.num },
      on: {
        input: function ($event) {
          if ($event.target.composing) {
            return
          }
          _vm.num = $event.target.value
        },
      },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "counter__button counter__button_right",
        on: { click: _vm.increment },
      },
      [_c("span", { staticClass: "lnr lnr-chevron-right" })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }